import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

type UseDeleteAreasMutation = {
	onSettled: () => void
}

export const useDeleteAreasMutation = ({ onSettled }: UseDeleteAreasMutation) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: deleteAreasMutation } = useMutation({
		mutationFn: (ids: number[]) => {
			return axiosPrivate.post(apiRoutes.areasDelete, { ids })
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.booths.all })
			useToast({
				type: 'success',
				message: t('Areas deleted')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled
	})

	return {
		deleteAreasMutation
	}
}
